class Footer {
  constructor(element) {
    this.$element = element;
    this.initialize();
  }

  initialize() {
    this.setVars();
    this.bindUI();
    this.bindObservers();

    this.fetchClosestOffice();
  }

  bindObservers() {
    const options = {
      rootMargin: '0px',
    };

    const observer = new IntersectionObserver( (entries) => {
      this.showBorder = entries[0]?.isIntersecting;
      this.render();
    }, options);

    observer.observe(this.$element);
  }

  bindUI() {
    this.$footerContents = this.$element.querySelector('[data-js-child="$footerContents"]');
    this.$officeTemplate = this.$element.querySelector('[data-js-child="$officeTemplate"]');
  }

  async fetchClosestOffice() {
    try {
      // Closest office metadata is saved in session storage so it's only
      // fetched once per session.
      const closestOffice = sessionStorage.getItem('closestOffice');
      if (closestOffice) {
        this.closestOffice = JSON.parse(closestOffice);
      } else {
        const response = await fetch(this.officesEndpoint);
        const offices = await response.json();

        if (offices?.closest) {
          const closestId = offices.closest.id;
          this.closestOffice = offices.points?.[closestId];

          sessionStorage.setItem('closestOffice', JSON.stringify(this.closestOffice));
        }
      }

      this.$footerContents.dataset.initialized = true;
      this.render();
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error(error);
    }
  }

  render() {
    if (this.showBorder) {
      this.$element.classList.add('animate-border-out');
    } else {
      this.$element.classList.remove('animate-border-out');
    }

    if (this.closestOffice && !this.$office) {
      // Office markup is defined in a <template> element and needs to be added
      // to the DOM
      if (this.$officeTemplate) {
        if (!this.$office) {
          // The template hasn't been cloned yet, so let's do it now and
          // populate it with values from the closest office.
          const clone = this.$officeTemplate.content.cloneNode(true);

          clone.querySelector('.office-name').innerText = this.closestOffice.name;
          clone.querySelector('.office-address').innerHTML = this.closestOffice.addressHtml;

          const $phoneNumbers = clone.querySelector('.office-phone-numbers');
          if (this.closestOffice.phoneNumbersHtml) {
            $phoneNumbers.innerHTML = this.closestOffice.phoneNumbersHtml;
          } else {
            $phoneNumbers.remove();
          }

          this.$footerContents.insertBefore(clone, this.$footerContents.children[1]);
          this.$office = this.$footerContents.querySelector('[data-js-child="$office"]');
        }
      }
    }
  }

  setVars() {
    this.officesEndpoint = this.$element.dataset.officesEndpoint;
  }
}

const footer = document.querySelector('[data-ref="siteFooter"]');
if (footer) {
  new Footer(footer);
}
